import { arrayMove } from "@dnd-kit/sortable";
import type { TimelineEventView } from "@/features/timeline/timeline.types";

export function moveTimelineEventIds(
  orderedEventIds: string[],
  eventId: string,
  direction: -1 | 1,
) {
  const currentIndex = orderedEventIds.indexOf(eventId);
  const nextIndex = currentIndex + direction;

  if (currentIndex < 0 || nextIndex < 0 || nextIndex >= orderedEventIds.length) {
    return orderedEventIds;
  }

  return arrayMove(orderedEventIds, currentIndex, nextIndex);
}

export function reorderTimelineEventIds(
  orderedEventIds: string[],
  activeEventId: string,
  overEventId: string,
) {
  const currentIndex = orderedEventIds.indexOf(activeEventId);
  const nextIndex = orderedEventIds.indexOf(overEventId);

  if (currentIndex < 0 || nextIndex < 0 || currentIndex === nextIndex) {
    return orderedEventIds;
  }

  return arrayMove(orderedEventIds, currentIndex, nextIndex);
}

export function applyTimelineEventOrder(
  events: TimelineEventView[],
  orderedEventIds: string[],
) {
  const eventsById = new Map(events.map((event) => [event.id, event]));

  return orderedEventIds
    .map((eventId, index) => {
      const event = eventsById.get(eventId);
      return event ? { ...event, sortOrder: index } : null;
    })
    .filter((event): event is TimelineEventView => Boolean(event));
}

export function sortTimelineEvents(events: TimelineEventView[]) {
  return [...events].sort((left, right) => left.sortOrder - right.sortOrder);
}
